import { ActionType } from '../../constants/ActionTypes'
import Utils from '../../services/Utils'

export default function uiReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.RESET_POPUPS_VISIBILITY:
            return {
                ...state,
                popupVisible: 0,
                selectedSubTab: 0,
                isMyProfilePopupVisible: false,
                isMessagesPopupVisible: false,
                isFilterPopupVisible: false
            }
        case ActionType.GET_CONTROLS_BEGIN:
            return {
                ...state,
                controls: {
                    ...state.controls,
                    [`is${action.payload}loading`]: true,
                    [`is${action.payload}inprocess`]: true,
                }
            }
        case ActionType.GET_CONTROLS_ERROR:
            return {
                ...state,
                error: action.payload,
                controls: {
                    ...state.controls,
                    [`is${action.payload}loading`]: false,
                }
            }
        case ActionType.GET_CONTROLS_SUCCESS:
            return {
                ...state,
                controls: {
                    ...state.controls,
                    [`is${action.payload.section}loading`]: false,
                    [action.payload.section]: action.payload.data[action.payload.section]
                }
            }
        case ActionType.RESET_AGENT_LOGIN:
            return {
                ...state,
                data: null
            }
        case ActionType.CHANGE_POPUP_VISIBILITY_NO_RESET:
        case ActionType.CHANGE_POPUP_VISIBILITY:
        case ActionType.CHANGE_MY_PROFILE_POPUP_VISIBILITY:
            const data = action.payload.data ? { data: action.payload.data } : null
            const tab = typeof action.payload === 'number' ? action.payload : action.payload.selectedTab;

            Utils.mobilePopupHandle(tab, action.payload?.selectedSubTab);

            return {
                ...state,
                isMyProfilePopupVisible: action.payload.visibility,
                selectedSubTab: action.payload.selectedSubTab,
                ...data,
                popupVisible: tab,
                callback: (typeof action.payload.callback === 'string' ? action.payload.callback : state.callback)
            }
        case ActionType.RESET_POPUP_CALLBACK:
            return {
                ...state,
                callback: false
            }
        case ActionType.CHANGE_MESSAGES_POPUP_VISIBILITY:
            return {
                ...state,
                isMessagesPopupVisible: action.payload
            }
        case ActionType.CHANGE_FITER_POPUP_VISIBILITY:
            return {
                ...state,
                isFilterPopupVisible: action.payload
            }
        case ActionType.CHANGE_MULTIVIEW_GRID:
            return {
                ...state,
                multiViewGrid: action.payload
            }
        default:
            return state;
    }
}